import { ChangeEvent } from 'react'

import { Input } from '..'

type OpenQuestionProps = {
  label: string
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const OpenQuestion = ({ label, onChange, value }: OpenQuestionProps) => (
  <Input
    name="open-question"
    type="text"
    label={label}
    labelColor="#000"
    hasQuestionInput
    placeholder="Resposta:"
    onChange={onChange}
    defaultValue={value}
  />
)

export default OpenQuestion
